var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isProcessing)?_c('OzLoadingText',{staticClass:"px-5 py-2 text-heading-4 text-center font-semibold",attrs:{"text":_vm.processingText}}):_c('OzContainedButton',{attrs:{"text":_vm.buttonText},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }